import apiClient from "../../../api/apiClient";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import {
  ActiveVerticalResponse,
  UsersVerticalsResponse,
  BannerImageResponse,
  BannerRetrieveRequest,
  GameHistoryListResponse,
  GetBalanceResponse,
  RetrieveGameHistoryRequest,
  CmsUserListResponse,
  MasterAffiliateTagsResponse,
} from "../models";
import { HomePageGameCategoriesResponse } from "../models/response/homePageGameCategoriesResponse";

export const homeApi = {
  retrieveBanners: async (data: BannerRetrieveRequest) => {
    const response = await apiClient.post<UnifiedResponse<BannerImageResponse>>(
      "/banner/retrieve",
      data,
      {
        headers: {
          requiresAuth: false,
        },
      },
    );
    return response.data;
  },

  fetchActiveVerticals: async () => {
    const response = await apiClient.get<
      UnifiedResponse<ActiveVerticalResponse>
    >("/Active/verticals_retrive", {
      headers: {
        requiresAuth: false,
      },
    });
    return response.data;
  },

  fetchUserVerticals: async () => {
    const response = await apiClient.get<
      UnifiedResponse<UsersVerticalsResponse>
    >("/users/users_verticals_retrive_by_userid")
    return response.data;
  },

  fetchUserBalance: async () => {
    const response = await apiClient.post<UnifiedResponse<GetBalanceResponse>>(
      "/users/wallet_amount/retrieve",
      {},
    );
    return response.data;
  },

  fetchGameHistory: async (data: RetrieveGameHistoryRequest) => {
    const response = await apiClient.post<
      UnifiedResponse<GameHistoryListResponse>
    >("/game/game_history/retrieve", data);
    return response.data;
  },

  fetchCmsUserList: async () => {
    const response = await apiClient.get<UnifiedResponse<CmsUserListResponse>>(
      "/cms/retrieve/userslist",
      {
        headers: {
          requiresAuth: false,
        },
      },
    );
    return response.data;
  },

  fetchMasterAffiliateTags: async () => {
    const response = await apiClient.get<
      UnifiedResponse<MasterAffiliateTagsResponse>
    >("/master_affiliate_tags/retrieve", {
      headers: {
        requiresAuth: false,
      },
    });
    return response.data;
  },
  fetchHomePageGameCategories: async () => {
    const response = await apiClient.get<
      UnifiedResponse<HomePageGameCategoriesResponse>
    >("/game/retrieve_homepage_categories", {
      headers: {
        requiresAuth: false,
      },
    });
    return response.data;
  },
};

export default homeApi;
